module.exports = __webpack_public_path__ + "img/cafeshop.7ce5cf65.jpg";